import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import {KahpooReverseService} from "../../../../services/kahpooreverse.service";
import * as XLSX from "xlsx";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {KahpooReverse} from "../../../../models/kahpooReverse.model";
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { KahpooCommission } from '../../../../models/kahpooCommission.model';
import { KahpooCommissionService } from '../../../../services/kahpooCommission.service';

@Component({
  selector: 'app-commission',
  templateUrl: './commission.component.html',
  styleUrls: ['./commission.component.scss']
})
export class CommissionComponent implements OnInit {
  listCommission: any = [];
  listCommissionTmp: any = [];
  totalGainKahpoo:number=0;
  totalGainKahpooByDate:number=0;
  sorted = 1;
  pageNumber: number = 1;
  pageSize: number = 20;
  totalItems: number;
  /*
-----------------------------         for all page attribute    --------------------------------
*/
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  searchValue: any;
  seller = false;
  perPage = 10;
  beginDate : any;
  endDate : any;
  userForm : FormGroup;

  constructor(private kahpooReverseService:KahpooReverseService, private authService: AuthService, private fb: FormBuilder,
  private router: Router,private datePipe: DatePipe, private kahpooCommissionService: KahpooCommissionService) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadKahpooCommissions();
      this.getTototal();
    },error=>{
    this.router.navigate(['/login']);
    });
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.loadKahpooCommissions();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.loadKahpooCommissions();
  }

  searchFilter_v1(){
    this.kahpooCommissionService.searchKahpooPost_1(this.searchValue)
      .subscribe((data) => {
        this.listCommission = data.content;
      });
  }

  // searchFilter($event: KeyboardEvent) {
  //   this.kahpooReverseService.getAllKahpooCommission().subscribe(rs=> {
  //     this.listCommission =rs;
  //     this.listCommission = this.listCommission.filter(value =>
  //       value?.sellerName?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.sellerUserName?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value.orderItem?.clientID?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.deliveredCode?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.orderID?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.receiverPhone?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.productID?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.productName?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.serviceName?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.serviceID?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.productShopID?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.orderItem?.serviceShopID?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.categoryOrderItem?.name?.toUpperCase().includes(this.search.toUpperCase()) ||
  //       value?.categoryOrderItem?.description?.toUpperCase().includes(this.search.toUpperCase())
  //     );
  //   }, (err) => {
  //     console.log('-----> err', err);
  //   });
  // }

  displayPerPage(value: any) {
    this.pageSize = parseInt(value, 10);
   // console.log("this.perPage : "+this.perPage);
    this.loadKahpooCommissions();
  }
  /*
  end for all page
   */


  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }
  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.iSfilterByDate = false;
    this.loadKahpooCommissions();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  // loadCommissions() {
  //   this.kahpooReverseService.getAllKahpooCommission().subscribe(rs=> {
  //     this.listCommission =rs;
  //     this.listCommissionTmp =rs;
  //     console.log("Liste des commissions...")
  //     console.log(this.listCommission)
  //     this.listCommission.forEach((element:any) => {
  //       this.totalGainKahpoo+=element.kahpooCommissionAmount * element.orderItem.quantity;
  //     });
  //   })
  // }

  getTototal(){
    this.kahpooCommissionService.getTototal().subscribe(rs=>{
      this.totalGainKahpoo = rs;
    });
  }

  loadKahpooCommissions() {
    this.kahpooCommissionService.getAllKahpooCommission(this.pageNumber - 1, this.pageSize).subscribe(rs=> {
      this.listCommission =rs.content;
      this.listCommissionTmp =rs.content;
      this.totalItems = rs.totalElements;
      //console.log("Liste des commissions...")
      //console.log(this.listCommission)
      // this.listCommission.forEach((element:any) => {
      //   this.totalGainKahpoo+=element.kahpooCommissionAmount * element.orderItem.quantity;
      // });
    })
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  iSfilterByDate = false;
  filterByDate() {

    let sessionId = localStorage.getItem("kapo_session_id");
    this.beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    this.endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    if (!this.beginDate || !this.endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.kahpooCommissionService.getAllCommissionsByDates(sessionId, this.beginDate, this.endDate).subscribe(data =>{
        this.listCommission = data.content;
        this.listCommissionTmp = data.content;
        this.totalItems = data.totalElements;
        // console.log("Liste des promotions des vendeurs...###");
        // console.log(data.content);
      });
      this.kahpooCommissionService.getTototalBeetwenDate(sessionId, this.beginDate, this.endDate).subscribe(rs=>{
        this.totalGainKahpooByDate = rs;
        this.iSfilterByDate = true;
      })
    }
  }

  /*
  filtre par date
   */

  filterUsers() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate < this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.listCommission = this.listCommissionTmp;
      this.listCommission = this.listCommission.filter((com) => {
        return (this.beginDate == null || com.orderItem?.saveAt >= this.beginDate) &&
          (this.endDate == null || com.orderItem?.saveAt  <= this.endDate);
      });
    }
  }

  resetFilter() {
    this.loadKahpooCommissions();
    this.beginDate = null;
    this.endDate = null;
  }

  trier(columnName: keyof any) {
    this.sorted = -this.sorted;
    this.listCommission.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }
}
